export default "__VITE_ASSET__688c5a67__"